export const MAP_SETTINGS_LOADING_SET = 'MAP_SETTINGS_LOADING/SET';
